import { useMutation, useQueryClient } from '@tanstack/react-query';
import { billingKeys } from '../../constants/billing';
import { ownedParkingKeys, ownedParkingOptions } from '../../constants/ownedParkings';
export function useOwnedParkingActions() {
    const queryClient = useQueryClient();
    const invalidateOwnedParkings = () => queryClient.invalidateQueries({ queryKey: ownedParkingKeys.all });
    const invalidateOwnedParkingsAndBillings = () => {
        queryClient.invalidateQueries({ queryKey: ownedParkingKeys.all });
        queryClient.invalidateQueries({ queryKey: billingKeys.all });
    };
    const getOwnedParkings = async (filter, scope) => {
        return await queryClient.fetchQuery(ownedParkingOptions.get(filter, scope));
    };
    const createMutation = useMutation({ ...ownedParkingOptions.create(), onSuccess: invalidateOwnedParkings });
    const updateMutation = useMutation({ ...ownedParkingOptions.update(), onSuccess: invalidateOwnedParkings });
    const submitForVerificationMutation = useMutation({
        ...ownedParkingOptions.submitForVerification(),
        onSuccess: invalidateOwnedParkings,
    });
    const deleteDraftMutation = useMutation({
        ...ownedParkingOptions.deleteDraft(),
        onSuccess: invalidateOwnedParkings,
    });
    const pauseMutation = useMutation({
        ...ownedParkingOptions.pause(),
        onSuccess: invalidateOwnedParkings,
    });
    const setLotModeMutation = useMutation({
        ...ownedParkingOptions.setLotMode(),
        onSuccess: invalidateOwnedParkings,
    });
    const assignBillingMutation = useMutation({
        ...ownedParkingOptions.assignBilling(),
        onSuccess: invalidateOwnedParkingsAndBillings,
    });
    const saveEntranceMutation = useMutation({
        ...ownedParkingOptions.saveEntrance(),
        onSuccess: invalidateOwnedParkings,
    });
    return {
        getOwnedParkings,
        createOwnedParking: createMutation.mutateAsync,
        updateOwnedParking: updateMutation.mutateAsync,
        submitForVerification: submitForVerificationMutation.mutateAsync,
        deleteDraftParking: deleteDraftMutation.mutateAsync,
        pauseOwnedParking: pauseMutation.mutateAsync,
        setOwnedParkingLotMode: setLotModeMutation.mutateAsync,
        assignBillingToParking: assignBillingMutation.mutateAsync,
        saveOwnedParkingEntrance: saveEntranceMutation.mutateAsync,
        savingOwnedParkings: createMutation.isPending ||
            updateMutation.isPending ||
            submitForVerificationMutation.isPending ||
            deleteDraftMutation.isPending ||
            pauseMutation.isPending ||
            setLotModeMutation.isPending ||
            assignBillingMutation.isPending ||
            saveEntranceMutation.isPending,
    };
}
